import { TrnState } from "../types";

const state: TrnState = {
  trn: "",
};

export default state;
